import { render } from "./radio_setting.vue?vue&type=template&id=716a6c2e&scoped=true"
import script from "./radio_setting.vue?vue&type=script&lang=js"
export * from "./radio_setting.vue?vue&type=script&lang=js"

import "./radio_setting.vue?vue&type=style&index=0&id=716a6c2e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716a6c2e"]])

export default __exports__